'use client';

import { useRouter } from 'next/navigation';

export const useUnifiedNavigate = () => {
  const nextRouter = useRouter();
  const unifiedNavigate = (to: string, options?: { replace?: boolean }) => {
    sessionStorage.setItem('redirectPath', to);
    if (options?.replace) {
      nextRouter.replace(to);
    } else {
      nextRouter.push(to);
    }
  };

  return unifiedNavigate;
};
